// @flow

import { RestClientAuthenticated } from '../network';
import { turanBaseURL } from '../../utils/urlUtils';

const eventsApi = {
  list: () => new RestClientAuthenticated(`${turanBaseURL()}/events/list`, 'GET').execute(),
  listCountryTab: () => new RestClientAuthenticated(`${turanBaseURL()}/events/country/tabs`, 'GET').execute(),
  fetchAllForCenter: (pcCode: string, includesOpening: boolean) => new RestClientAuthenticated(`${turanBaseURL()}/events/list/${pcCode}`, 'GET')
    .addParam('includesOpening', includesOpening)
    .execute(),
  hasEventData: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/events/shopping-centers/${pcId}/data`, 'GET').execute(),
  fetchEvent: (idEvent: number) => new RestClientAuthenticated(`${turanBaseURL()}/events/${idEvent}`, 'GET').execute(),
  fetchEventSCTile: (pcId: number) => new RestClientAuthenticated(`${turanBaseURL()}/events/shoppingCenter/${pcId}`, 'GET').execute(),
  fetchShoppingCenters: (countryCode: number) => new RestClientAuthenticated(`${turanBaseURL()}/events/country/${countryCode}`, 'GET').execute(),
};

export default eventsApi;
